import React, { useState, useEffect, useCallback, lazy, Suspense } from 'react';
import './SearchBar.css';

const CommandPalette = lazy(() => import('./CommandPalette'));

const SearchBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Ctrl+K / Cmd+K shortcut
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        setIsOpen(true);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleOpen = useCallback(() => setIsOpen(true), []);
  const handleClose = useCallback(() => setIsOpen(false), []);

  // Detect Mac vs Windows for shortcut display
  // navigator.platform is deprecated; prefer navigator.userAgentData when available
  const isMac = typeof navigator !== 'undefined' && (
    navigator.userAgentData?.platform === 'macOS' ||
    /Mac|iPod|iPhone|iPad/.test(navigator.platform || '')
  );
  const shortcutLabel = isMac ? '\u2318K' : 'Ctrl+K';

  return (
    <div className="search-bar">
      <button
        className="search-bar__trigger"
        onClick={handleOpen}
        aria-label="Open search"
        type="button"
      >
        <span className="search-bar__icon" aria-hidden="true">
          {'\uD83D\uDD0D'}
        </span>
        <span className="search-bar__placeholder">Search items, ships, locations...</span>
        <span className="search-bar__shortcut">{shortcutLabel}</span>
      </button>

      {isOpen && (
        <Suspense fallback={null}>
          <CommandPalette onClose={handleClose} />
        </Suspense>
      )}
    </div>
  );
};

export default SearchBar;
